/**
 * UssaPointsModal — Download USSA points CSVs by list number.
 * Auto-detects the current list period from listPeriods2026.json.
 */
import React, { useState, useMemo } from 'react';
import listPeriods from '../data/listPeriods2026.json';
import './PointsModal.css';

const MONTHS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
const fmtDate = (iso) => { const [,m,d] = iso.split('-'); return `${MONTHS[+m-1]} ${+d}`; };

function UssaPointsModal({ isOpen, onClose, raceDate }) {
  const currentList = useMemo(() => {
    const today = new Date().toISOString().slice(0, 10);
    return listPeriods.ussa.lists.find(l => today >= l.validFrom && today <= l.validTo) || null;
  }, []);

  const [pointsList, setPointsList] = useState('');
  const [distanceURL, setDistanceURL] = useState(null);
  const [sprintURL, setSprintURL] = useState(null);
  const [overallURL, setOverallURL] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  if (!isOpen) return null;

  const effectiveList = pointsList || (currentList ? String(currentList.listNumber) : '1');

  const handleFetch = () => {
    setIsLoading(true);
    setError(null);
    const body = new FormData();
    body.append('pointsList', effectiveList);
    body.append('racers', []);
    body.append('return_csv', true);
    body.append('date', (raceDate || new Date().toISOString().slice(0, 10)).split('-'));

    fetch('https://2ibtetclowg2xpmh47qlpd7egy0tneqv.lambda-url.us-west-2.on.aws/', {
      method: 'POST',
      body,
    })
      .then(res => res.json())
      .then(data => {
        setSprintURL(data[0]);
        setDistanceURL(data[1]);
        setOverallURL(data[2]);
        setIsLoading(false);
      })
      .catch(err => {
        setError(err.message);
        setIsLoading(false);
      });
  };

  const handleClose = () => {
    setDistanceURL(null);
    setSprintURL(null);
    setOverallURL(null);
    setPointsList('');
    setError(null);
    onClose();
  };

  return (
    <div className="points-modal-overlay" onClick={handleClose}>
      <div className="points-modal" onClick={e => e.stopPropagation()}>
        <div className="points-modal-header">
          <h2>Download USSA Points</h2>
          <button className="points-modal-close" onClick={handleClose}>&times;</button>
        </div>
        {currentList && (
          <div className="points-modal-period">
            List {currentList.listNumber} ({currentList.code}) — valid {fmtDate(currentList.validFrom)} to {fmtDate(currentList.validTo)}
          </div>
        )}
        <div className="points-modal-form">
          <label>List #</label>
          <input
            type="text"
            value={pointsList}
            onChange={e => setPointsList(e.target.value)}
            placeholder={currentList ? String(currentList.listNumber) : '1'}
          />
          <button onClick={handleFetch} disabled={isLoading}>
            {isLoading ? 'Loading\u2026' : 'Get USSA Lists'}
          </button>
        </div>
        {error && <div className="points-modal-error">{error}</div>}
        {(distanceURL || sprintURL || overallURL) && (
          <div className="points-modal-links">
            {distanceURL && <a href={distanceURL} download="ussa_distance.csv">Download Distance CSV</a>}
            {sprintURL && <a href={sprintURL} download="ussa_sprint.csv">Download Sprint CSV</a>}
            {overallURL && <a href={overallURL} download="ussa_overall.csv">Download Overall CSV</a>}
          </div>
        )}
      </div>
    </div>
  );
}

export default UssaPointsModal;
